/**
 * Запрашивает persistent storage у браузера / WKWebView.
 *
 * Без этого:
 * - WKWebView (iOS Safari/Capacitor) evict'ит IndexedDB через 7 дней без user interaction
 * - Desktop Safari ITP делает то же самое
 * - Chrome обычно даёт persistent автоматически по installprompt heuristics
 *
 * Возвращает финальное состояние: persisted | denied | unavailable.
 */
export type PersistentStorageState = 'persisted' | 'denied' | 'unavailable';

export async function requestPersistentStorage(): Promise<PersistentStorageState> {
  if (typeof navigator === 'undefined' || !navigator.storage?.persist) {
    return 'unavailable';
  }
  try {
    const already = await navigator.storage.persisted?.();
    if (already) return 'persisted';
    const granted = await navigator.storage.persist();
    return granted ? 'persisted' : 'denied';
  } catch (err) {
    console.error('[storage] persist() error:', err);
    return 'unavailable';
  }
}
